import React, { createContext, useContext, useState, useCallback } from 'react';
import { useTheme } from './ThemeContext';

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([]);
  const { resolved: theme } = useTheme();

  const addNotification = useCallback((message, type = 'info') => {
    const id = Date.now().toString();
    setNotifications((prev) => [...prev, { id, message, type }]);
    
    // Auto-dismiss after 3 seconds
    setTimeout(() => {
      setNotifications((prev) => prev.filter((n) => n.id !== id));
    }, 3000);
  }, []);

  const removeNotification = useCallback((id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  }, []);

  return (
    <NotificationContext.Provider value={{ addNotification, removeNotification }}>
      {children}
      {/* Render toasts */}
      <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 pointer-events-none">
        {notifications.map((n) => (
          <div
            key={n.id}
            className="px-4 py-3 rounded shadow-lg text-sm font-medium pointer-events-auto flex items-center justify-between min-w-[250px]"
            style={{
              backgroundColor: n.type === 'error' ? '#fee2e2' : n.type === 'warning' ? '#fef3c7' : theme.ui?.bgSecondary || '#fff',
              color: n.type === 'error' ? '#991b1b' : n.type === 'warning' ? '#92400e' : theme.ui?.text || '#000',
              border: `1px solid ${n.type === 'error' ? '#f87171' : n.type === 'warning' ? '#fbbf24' : theme.ui?.border || '#e5e7eb'}`,
            }}
          >
            <span>{n.message}</span>
            <button
              onClick={() => removeNotification(n.id)}
              className="ml-4 opacity-50 hover:opacity-100"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </NotificationContext.Provider>
  );
}

export function useNotification() {
  const ctx = useContext(NotificationContext);
  if (!ctx) throw new Error('useNotification must be used within a NotificationProvider');
  return ctx;
}
